function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    shapeRendering: "auto",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75 5c-2.0516 0-3.75 1.6984-3.75 3.75v13.5c0 2.0516 1.6984 3.75 3.75 3.75h21.5c2.0516 0 3.75-1.6984 3.75-3.75v-13.5c0-2.0516-1.6984-3.75-3.75-3.75zm0 3h21.5c0.44145 0 0.75 0.30855 0.75 0.75v13.5c0 0.44145-0.30855 0.75-0.75 0.75h-21.5c-0.44145 0-0.75-0.30855-0.75-0.75v-13.5c0-0.44145 0.30855-0.75 0.75-0.75z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 0v3h8v-3h-8z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 0v3h8v-3h-8z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.547 14.127a0.91359 0.91359 0 0 0-0.91406 0.91211 0.91359 0.91359 0 0 0 0.91406 0.91406h4.3848a0.91359 0.91359 0 0 0 0.91406-0.91406 0.91359 0.91359 0 0 0-0.91406-0.91211z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.8613 12.104a0.91359 0.91359 0 0 0-0.91406 0.91406v1.2793h-1.2793a0.91359 0.91359 0 0 0-0.91406 0.91406 0.91359 0.91359 0 0 0 0.91406 0.91211h1.2793v1.2793a0.91359 0.91359 0 0 0 0.91406 0.91406 0.91359 0.91359 0 0 0 0.91406-0.91406v-1.2793h1.2773a0.91359 0.91359 0 0 0 0.91406-0.91211 0.91359 0.91359 0 0 0-0.91406-0.91406h-1.2773v-1.2793a0.91359 0.91359 0 0 0-0.91406-0.91406z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.18d203a4383a2db62b56e0efe8037b45.svg";
export { ForwardRef as ReactComponent };